// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';
import { Modal } from '../ui/Modal';

const SHORTCUT_GROUPS = [
    { title: 'Navigation', rows: [
      { keys: ['⌘','K'], desc: 'Open command palette' },
      { keys: ['⌘','.'], desc: 'Open quick actions' },
      { keys: ['G','H'], desc: 'Go to dashboard' },
      { keys: ['G','E'], desc: 'Go to events' },
      { keys: ['G','O'], desc: 'Go to orders' },
      { keys: ['G','T'], desc: 'Go to transactions' },
      { keys: ['G','P'], desc: 'Go to payouts' },
      { keys: ['G','C'], desc: 'Go to channels' },
      { keys: ['G','S'], desc: 'Go to sales setup' },
      { keys: ['G','A'], desc: 'Go to access control' },
      { keys: ['G','R'], desc: 'Go to risk & compliance' },
      { keys: ['G','V'], desc: 'Go to venues' },
      { keys: ['G','U'], desc: 'Go to users & customers' },
    ] },
    { title: 'Actions', rows: [
      { keys: ['N','O'], desc: 'New manual order' },
      { keys: ['N','E'], desc: 'Review event requests' },
    ] },
    { title: 'Search', rows: [
      { keys: ['/'],     desc: "Search this page (falls back to the palette if it has none)" },
      { keys: ['⌘','K'], desc: 'Search across the console' },
    ] },
    // Composer shortcuts are CONTEXTUAL — they only exist while a message composer has
    // focus, which is why plain Enter stays a newline there (see submitOnCmdEnter).
    { title: 'Message composers', rows: [
      { keys: ['⌘','↵'], desc: 'Send the WhatsApp reply you are writing (Chat, Support)' },
    ] },
    { title: 'General', rows: [
      { keys: ['?'],     desc: 'Open this help' },
      { keys: ['esc'],   desc: 'Close palette / dialog' },
    ] },
  ];

export const KeyboardShortcutsHelp = ({ open, onClose }) => {
  if (!open) return null;
  const groups = SHORTCUT_GROUPS;
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" sub="Press ⌘K anywhere to open the command palette" width="max-w-[520px]">
      <div className="space-y-5">
        {groups.map(g => (
          <div key={g.title}>
            <div className="text-[10.5px] uppercase tracking-[0.06em] font-semibold text-[#6B7280] mb-2">{g.title}</div>
            <div className="space-y-1.5">
              {g.rows.map((r, i) => (
                <div key={i} className="flex items-center justify-between py-1">
                  <span className="text-[12.5px] text-[#1F2937]">{r.desc}</span>
                  <div className="flex items-center gap-1">
                    {r.keys.map((k, j) => (
                      <kbd key={j} className="text-[11px] text-[#1F2937] bg-[#FBFAF7] border border-[#E6E4E1] rounded px-1.5 py-0.5 font-mono min-w-[24px] text-center">{k}</kbd>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};


// ============================================================
// MAIN APP SHELL
// ============================================================

